import { selectAppConfig } from "./selectAppConfig";

export const selectNormalizedModel = (state) => {
  return selectAppConfig(state).normalized_model;
}
